import type { WorldLayerHandle } from './IRenderer';

/** Minimal structural shapes — a Pixi Container satisfies ContainerLike, the
 *  overlay's worldContainer satisfies ParentLike. Injected so this is pure. */
interface ContainerLike {
  zIndex: number;
  alpha: number;
  addChild(c: unknown): void;
  destroy(opts?: { children?: boolean }): void;
}
interface ParentLike {
  addChild(c: unknown): void;
  removeChild(c: unknown): void;
}

/**
 * Wire a freshly-created container into `parent` at `depth`, returning the opaque
 * WorldLayerHandle the atmosphere holds (Scene FX v3 M1 — per-layer opacity).
 * Pure (substrate objects injected) so it unit-tests without Pixi;
 * PixiOverlayHost passes a real Container + its worldContainer.
 */
export function makeWorldLayerHandle(parent: ParentLike, container: ContainerLike, depth: number): WorldLayerHandle {
  container.zIndex = depth;
  parent.addChild(container);
  return {
    addChild: (child) => container.addChild(child),
    setAlpha: (alpha) => { container.alpha = alpha; },
    destroy: () => {
      try { parent.removeChild(container); } catch { /* already gone */ }
      try { container.destroy({ children: true }); } catch { /* already gone */ }
    },
  };
}
